// src/components/Home.js

import React, { useContext } from 'react';
import CarSlideShow from './shared/slide/CarSlideShow';
import Header from './shared/header';
import SpaceDiv from './shared/spaceDiv';
import Footer from './shared/footer';
import ContactUsSection from './About';
import ViewButtons from './shared/displayButtons';
import { buttons, cars } from '../global-const';
import CarContext from './shared/carProvider';

const Home = () => {
  // const { cars, loading } = useContext(CarContext);  // Consume car data from context

  // if (loading) {
  //   <div>
  //     <Header />
  //     <ViewButtons buttons={buttons} />
  //     <ContactUsSection />
  //     <SpaceDiv />
  //     <Footer />
  //   </div>
  // }

  return (
    <div>
      <Header />
      <CarSlideShow cars={cars} />
      <ViewButtons buttons={buttons} />
      <ContactUsSection />
      <SpaceDiv />
      <Footer />
    </div>
  );
};

export default Home;
